const MAX_IMAGE_CONTAINER_WIDTH = 900;
export const SRC_SET_WIDTHS = [MAX_IMAGE_CONTAINER_WIDTH, MAX_IMAGE_CONTAINER_WIDTH * 2];
export const SIZES = `${MAX_IMAGE_CONTAINER_WIDTH}px`;
